// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.announcement-basic {
  margin-top: 32px;
  border-radius: 6px;
  border: 1px solid var(--blue-80, #355C7D);
  background: var(--10, #F5FAFF);
  padding: 12px 16px;
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  /* 19.6px */
}
.announcement-basic .row {
  margin-top: 16px;
  text-align: right;
}
.announcement-basic .row span.link {
  cursor: pointer;
  color: var(--blue-80, #355C7D);
  text-align: right;
  font-family: Inter;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  /* 19.6px */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.title-review {
  background-color: #FDFCFF;
  color: #855791;
  border: 1px solid #D7B8E5;
}

.link-review {
  color: #855791 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Atoms/Announcements/AnnouncementBasic.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EAEA,kBAAA;EACA,yCAAA;EACA,8BAAA;EACA,kBAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AADF;AAGE;EACE,gBAAA;EACA,iBAAA;AADJ;AAGI;EACE,eAAA;EAEA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,4BAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCAAA;AAFN;;AAOA;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF","sourcesContent":[".announcement-basic {\n  margin-top: 32px;\n\n  border-radius: 6px;\n  border: 1px solid var(--blue-80, #355C7D);\n  background: var(--10, #F5FAFF);\n  padding: 12px 16px;\n\n  color: var(--900-grey, #2A2F3C);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  /* 19.6px */\n\n  .row {\n    margin-top: 16px;\n    text-align: right;\n\n    span.link {\n      cursor: pointer;\n\n      color: var(--blue-80, #355C7D);\n      text-align: right;\n      font-family: Inter;\n      font-size: 14px !important;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 140%;\n      /* 19.6px */\n      text-decoration-line: underline;\n      text-decoration-style: solid;\n      text-decoration-skip-ink: none;\n      text-decoration-thickness: auto;\n      text-underline-offset: auto;\n      text-underline-position: from-font;\n    }\n  }\n}\n\n.title-review {\n  background-color: #FDFCFF;\n  color: #855791;\n  border: 1px solid #D7B8E5;\n}\n\n.link-review {\n  color: #855791 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
